module.exports = __webpack_public_path__ + "static/media/bled_sunrise_cinemagraph_v2_long.f49259f0.webm";